import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { indexApi } from './indexApi'
import { inquiryApi } from './inquiryApi'
import { orderApi } from './orderApi'
import { pointApi } from './pointApi'
import { productApi } from './productApi'
import { questionApi } from './questionApi'
import { userApi } from './userApi'

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [orderApi.reducerPath]: orderApi.reducer,
    [questionApi.reducerPath]: questionApi.reducer,
    [inquiryApi.reducerPath]: inquiryApi.reducer,
    [indexApi.reducerPath]: indexApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [pointApi.reducerPath]: pointApi.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling, and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      orderApi.middleware, 
      questionApi.middleware, 
      inquiryApi.middleware, 
      indexApi.middleware, 
      productApi.middleware, 
      userApi.middleware,
      pointApi.middleware
    )
})

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)